import { render, staticRenderFns } from "./HasNoCardAlert.vue?vue&type=template&id=1db2f724&"
import script from "./HasNoCardAlert.vue?vue&type=script&lang=js&"
export * from "./HasNoCardAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1db2f724')) {
      api.createRecord('1db2f724', component.options)
    } else {
      api.reload('1db2f724', component.options)
    }
    module.hot.accept("./HasNoCardAlert.vue?vue&type=template&id=1db2f724&", function () {
      api.rerender('1db2f724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Privacy/HasNoCardAlert.vue"
export default component.exports